import { PLAY_S_PER_ISLAND_H } from '../survival/DayClock';

/** The Harrow pulse: every 73 island minutes. */
export const PULSE_ISLAND_MIN = 73;
export const PULSE_HOLD_S = 8;
const PLAY_S_PER_ISLAND_MIN = PLAY_S_PER_ISLAND_H / 60;

export type PulseSnap = {
  active: boolean;
  nextIn: number;
  count: number;
  inWindow: boolean;
  etaPlayS: number;
};

export class Pulse {
  active = false;
  left = 0;
  sealed = false;
  count = 0;
  private lastPhase = 0;

  /** QA / FEED lock: open an 8 s window now. */
  force(): void {
    if (this.sealed) {
      return;
    }
    this.active = true;
    this.left = PULSE_HOLD_S;
    this.count += 1;
  }

  tick(dtSeconds: number, todMinutes: number): PulseSnap {
    if (this.sealed) {
      this.active = false;
      this.left = 0;
      return this.snap(PULSE_ISLAND_MIN);
    }
    const phase = ((todMinutes % PULSE_ISLAND_MIN) + PULSE_ISLAND_MIN) % PULSE_ISLAND_MIN;
    if (this.lastPhase > 0 && phase < this.lastPhase) {
      this.active = true;
      this.left = PULSE_HOLD_S;
      this.count += 1;
    }
    this.lastPhase = phase;
    if (this.active) {
      this.left -= dtSeconds;
      if (this.left <= 0) {
        this.active = false;
        this.left = 0;
      }
    }
    return this.snap(PULSE_ISLAND_MIN - phase);
  }

  private snap(nextIn: number): PulseSnap {
    return {
      active: this.active,
      nextIn,
      count: this.count,
      inWindow: this.active,
      etaPlayS: nextIn * PLAY_S_PER_ISLAND_MIN,
    };
  }
}
